import React from 'react'
import FormCuadroDeMando from './FormCuadroDeMando'

export default function CuadroDeMando () {
  return (
    <div id='consulta-cuadro-mando-container'>
      <FormCuadroDeMando />
    </div>
  )
}
